import { useMutation } from '@tanstack/react-query';
import { submitDemoRequest, type DemoRequestData } from '../api';
import toast from 'react-hot-toast';

export const useDemoMutation = () => {
  return useMutation({
    mutationFn: (data: DemoRequestData) => submitDemoRequest(data),
    onSuccess: (response) => {
      toast.success(
        response.data?.message ||
          'Demo request submitted successfully! We will contact you soon.',
        {
          duration: 6000,
        },
      );
    },
    onError: (
      error: Error & { response?: { data?: { message?: string } } },
    ) => {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        'Failed to submit demo request. Please try again later.';

      toast.error(errorMessage, {
        duration: 5000,
      });
    },
  });
};
